/**
 * Composite keyset position: `(sortVal, id)` tuple comparison for stable
 * pagination when many rows share the same sort value.
 */
export interface KeysetPaginationCursor<T, K extends keyof T = keyof T> {
	sortVal: T[K];
	id: string;
}

/** Scalar sort value or composite `{ sortVal, id }` keyset position. */
export type PaginationCursor<T, K extends keyof T = keyof T> = T[K] | KeysetPaginationCursor<T, K>;

export interface RequestPaginationInterface<T, K extends keyof T = keyof T> {
	page?: number;
	size?: number;
	sortBy?: K;
	orderBy?: OrderByEnum;
	/** When set, `page` is ignored. */
	cursor?: PaginationCursor<T, K>;
}

export enum OrderByEnum {
	ASC = 'ASC',
	DESC = 'DESC',
}
